<template>
  <transition
    name="modal"
    :key="_uid"
  >
    <div
      v-warp:app.prepend
      v-if="isActive"
      class="c-modal"
    >
      <div
        class="mask"
        @mousedown="handleMaskClick"
      >
        <div
          class="container"
          ref="container"
        >
          <header>
            <c-button
              size="lg"
              v-if="mobileAction && mobile"
              icon="chevron-left"
              alternative
              @click.native="close"
            />
            <c-title
              class="title"
              :icon="icon"
              icon-size="17"
              size="2"
              v-if="title"
            >
              {{ title }}
            </c-title>
            <div
              class="actions"
              v-if="actions"
            >
              <slot name="actions" />
              <c-button
                data-cy="close-cmodal-button"
                size="md"
                icon="cross"
                v-if="!mobile"
                alternative
                @click.native="close"
              />
            </div>
          </header>
          <slot name="header" />
          <div
            class="body"
            v-scroll
          >
            <slot />
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Boolean,
      default: true
    },
    mobileAction: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isActive: this.show || false,
      mobile: false
    }
  },
  watch: {
    show (value) {
      this.isActive = value
    },
    isActive () {
      if (typeof window !== 'undefined') {
        document
          .documentElement
          .classList[this.isActive ? 'add' : 'remove']('-modal-open')
      }
    }
  },
  mounted () {
    document.addEventListener('keyup', this.keyPress)
    window.addEventListener('resize', this.handleWidth)
    this.handleWidth()
  },
  beforeDestroy () {
    document.removeEventListener('keyup', this.keyPress)
    window.removeEventListener('resize', this.handleWidth)
  },
  methods: {
    close () {
      this.$emit('close')
    },
    keyPress (event) {
      if (event.keyCode === 27) this.close()
    },
    handleMaskClick (event) {
      if (event.target.contains(this.$refs.container)) this.close()
    },
    handleWidth () {
      this.mobile = window.innerWidth < 768
    }
  }
}
</script>

<style lang="scss">
@import '~@styles/convenia-components/reference.scss';

$c-modal-mask-background-color: rgba(#6b728e, 0.8) !default;

$c-modal-header-padding: 18px !default;
$c-modal-header-height: 36px !default;

$c-modal-header-title-color: #8d92b1 !default;
$c-modal-header-title-font-size: 13px !default;
$c-modal-header-title-font-family: sans-serif !default;
$c-modal-header-title-font-weight: 300 !default;

.-modal-open {
  overflow: hidden;

  .c-wrapper > :not(.c-modal) {
    filter: blur(5px);
    pointer-events: none;
  }

  .c-modal {
    pointer-events: all;
  }
}

.c-modal {
  pointer-events: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3;
  transition: all 0.5s ease;

  @include small-down { z-index: 1100; }

  & > .mask {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row wrap;
    position: relative;
    background-color: $c-modal-mask-background-color;
    z-index: 1;
  }

  & .container {
    pointer-events: all;
    margin: auto;
    background-color: #fff;
    z-index: 2;

    @include small-down {
      width: 100%;
      height: 100%;
    }

    @include small-up {
      width: 50%;
      min-width: 320px;
      height: 50%;
    }
  }

  & header {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: flex-start;
    padding: $c-modal-header-padding;

    & > .title {
      margin: 0;

      @include small-down { display: none; }
    }
  }

  & .actions {
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    margin-left: $spacing;
    @include small-up { margin-left: auto; }

    // tmp - enquanto não temos inputs
    input {
      &:focus,
      &:active { outline: none; }
      &::placeholder { color: #daddec; }
      color: #8d92b1;
      margin-right: 14px;
      height: 32px;
      border: 1px solid #e9eaee;
      line-height: 30px;
      border-radius: $c-modal-header-padding;
      padding-left: $c-modal-header-padding;
      padding-right: $c-modal-header-padding;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  & .body {
    height: calc(100% - #{$c-modal-header-height} - #{$c-modal-header-padding} * 2);

    & > .footer {
      display: none;

      @include small-down {
        position: fixed;
        cursor: pointer;
        display: flex;
        bottom: 0;
        left: 0;
        background-color: #e9eaee;
        flex-flow: row wrap;
        width: 100%;
        height: inner-base(3);
        z-index: 3;

        & > .icon {
          fill: #989cb9;
          margin: auto;
          margin-right: 6px;
        }

        & > .text {
          color: #989cb9;
          margin: auto;
          margin-left: 0;
          font-weight: 500;
          pointer-events: none;
        }
      }
    }

    @include small-up { border-top: 1px solid #e9eaee; }
  }
}

.modal-enter { opacity: 0; }
.modal-leave-active { opacity: 0; }
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/convenia-components/CModal.vue